/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation PhoneNumberoDirectoryUpsertMutation($phoneNumberoDirectoryId: ID, $displayName: String) {
  PhoneNumberoDirectoryUpsert(phoneNumberoDirectoryId: $phoneNumberoDirectoryId, displayName: $displayName) {
    id
    message
    status
  }
}
`
